import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './customer-account.reducer';

export const CustomerAccount = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const customerAccountList = useAppSelector(state => state.customerAccount.entities);
  const loading = useAppSelector(state => state.customerAccount.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="customer-account-heading" data-cy="CustomerAccountHeading">
        <Translate contentKey="crawlerBackendApp.customerAccount.home.title">Customer Accounts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.customerAccount.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/customer-account/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.customerAccount.home.createLabel">
              Create new Customer Account
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {customerAccountList && customerAccountList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.customerAccount.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('isContact')}>
                  <Translate contentKey="crawlerBackendApp.customerAccount.isContact">Is Contact</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isContact')} />
                </th>
                <th className="hand" onClick={sort('collectiveInvoice')}>
                  <Translate contentKey="crawlerBackendApp.customerAccount.collectiveInvoice">
                    Collective Invoice
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectiveInvoice')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.customerAccount.billingAddress">Billing Address</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.customerAccount.bankAccount">Bank Account</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.customerAccount.contractHolder">Contract Holder</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {customerAccountList.map((customerAccount, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/customer-account/${customerAccount.id}`} color="link" size="sm">
                      {customerAccount.id}
                    </Button>
                  </td>
                  <td>{customerAccount.isContact ? 'true' : 'false'}</td>
                  <td>{customerAccount.collectiveInvoice ? 'true' : 'false'}</td>
                  <td>
                    {customerAccount.billingAddress ? (
                      <Link to={`/address/${customerAccount.billingAddress.id}`}>
                        {customerAccount.billingAddress.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {customerAccount.bankAccount ? (
                      <Link to={`/bank-account/${customerAccount.bankAccount.id}`}>
                        {customerAccount.bankAccount.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {customerAccount.contractHolder ? (
                      <Link to={`/contact/${customerAccount.contractHolder.id}`}>
                        {customerAccount.contractHolder.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/customer-account/${customerAccount.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/customer-account/${customerAccount.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/customer-account/${customerAccount.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.customerAccount.home.notFound">
                No Customer Accounts found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CustomerAccount;
